<template>
    <div>
        <breadCrumb
            :icon="'fa-user-check'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_consentform_member`)"
            :subSubCategory="''">
        </breadCrumb>

        <div class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4">

                    <div class="row">
                        <div class="col-12 col-md-6 mb-2">
                            <div class="form-group">
                                <div class="input-group">
                                    <div class="input-group-prepend w-100">
                                        <label class="input-group-text border-right-0">
                                            <i class="fas fa-search"></i>
                                        </label>
                                        <multiselect
                                            v-model="selectedMember"
                                            :options="members"
                                            track-by="memberID"
                                            label="text"
                                            :show-labels="false"
                                            openDirection="below"
                                            @select="filterByMember">
                                            <span slot="noResult">
                                                {{ $t('table.no_records') }}
                                            </span>
                                            <template slot="option" slot-scope="{ option }">
                                                {{ option.text }}
                                            </template>
                                        </multiselect>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <ConsentFormView
                        ref="consentFormView"
                        class="tab-pane p-0"
                        @onSignClick="onSignClick"
                        @onFormClick="onFormClick">
                    </ConsentFormView>

                </div>
            </div>
        </div>

        <ConsentFormForm
            ref="consentFormForm"
            @onItemChange="onItemChange">
        </ConsentFormForm>
    </div>
</template>
<script>
import BreadCrumb from './../../Bread_Crumb'
import ConsentFormView from './ConsentFormView'
// import ConsentListView from './ConsentListView'
import ConsentFormForm from './ConsentForm_Form'
import { getMemberMap } from './../../../../assets/js/dashboard/dashboard.js'

export default {
    name: "consentForm",
    components: {
        ConsentFormView,
        // ConsentListView,
        ConsentFormForm,
        BreadCrumb,
    },
    data() {
        let tabs = [
            { id: 'form', text: 'Consent Form' },
            // { id: 'list', text: 'Consent List' }
        ]

        return {
            filterObj: {},

            members: [],
            memberMap: {},
            selectedMember: null,

            tabs: tabs,
            selectedTab: tabs[0].id,

            editToggleModal: true,
            sTitle: '',
        }
    },
    methods: {
        filterByMember(val) {
            this.selectedMember = val
            this.$refs['consentFormView'].setItems(this.selectedMember)
        },

        onSignClick(member, item) {
            this.$refs['consentFormForm'].showModal(member, item, null)
        },
        onFormClick(member, item) {
            this.$refs['consentFormForm'].showModal(member, null, item)
        },

        onItemChange() {
            this.$refs['consentFormView'].setItems(this.selectedMember)
        },
    },
    async mounted() {
        this.memberMap = await getMemberMap(this)
        for (let memberID in this.memberMap) {
            let member = this.memberMap[memberID]
            member['text'] = ''
            if (member['name']) {
                member['text'] += member['name']
            }
            if (member['mobile']) {
                if (member['text']) {
                    member['text'] += ' - '
                }
                member['text'] += member['mobile']
            }
            if (member['text']) {
                this.members.push(this.memberMap[memberID])
            }
        }
    },
}
</script>
<style scoped>
.nav-link {
    cursor: pointer;
}
</style>